<template>
  <div class="animated revealUp">
    <div>
      <div class="mb-5">
        <div class="d-flex justify-content-between align-item-center mb-3">
          <div class="section-title">
            {{ $tc("add") }} {{ $tc("subrecipe", 1) }}
          </div>
          <div>
            <router-link class="btn-blue" to="subrecipes"
              >{{ $tc("subrecipe", 2) }} {{ $tc("list", 2) }}</router-link
            >
          </div>
        </div>

        <div class="white-wrapper">
          <form class="row">
            <div class="col-lg-6 col-xl-3 align-self-center mb-2">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    type="text"
                    v-model="recipeDetails.recipe_name"
                    name="recipename"
                    id="recipename"
                    v-validate="'required'"
                    placeholder="."
                  />
                  <label>{{ $tc("item", 1) }} {{ $t("name") }}</label>
                </div>
                <!-- <Tooltip :title="$t('recipe_name_tooltip')" /> -->
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('recipename')">{{
                  errors.first("recipename")
                }}</span>
              </p>
            </div>

            <div class="col-lg-6 col-xl-3 align-self-center mb-2">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    type="text"
                    v-model="recipeDetails.recipe_description"
                    name="recipedesc"
                    id="recipedesc"
                    placeholder="."
                    v-validate="'required'"
                  />
                  <label>{{ $tc("recipe", 1) }} {{ $t("description") }}</label>
                </div>
                <!-- <Tooltip :title="$t('recipe_description_tooltip')" /> -->
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('recipedesc')">{{
                  errors.first("recipedesc")
                }}</span>
              </p>
            </div>

            <div
              class="
                col-lg-6 col-xl-6
                align-self-center
                d-flex
                mb-2
                pb-3
                pr-5
                justify-content-between
              "
            >
              <div class="d-flex align-items-center">
                <b-form-checkbox
                  v-model="recipeDetails.recipe_is_active"
                  class="j-checkbox"
                  name="recipe_is_active"
                  id="recipe_is_active"
                ></b-form-checkbox>
                <label for="recipe_is_active" class="mb-0 mr-3">{{
                  $t("active")
                }}</label>
              </div>
            </div>

            <div
              v-if="recipeDetails.recipe_is_combo"
              class="col-lg-6 col-xl-3 align-self-center mb-4"
            >
              <multiselect
                v-model="recipes"
                track-by="recipe_name"
                label="recipe_name"
                :options="ms_recipes"
                @select="onSelectRecipe"
                @remove="onRemoveRecipe"
                :multiple="true"
              ></multiselect>
              <p class="error_message">
                <span></span>
              </p>
            </div>

            <div class="col-lg-12 col-xl-12 align-self-center">
              <div class="recipe-box-container">
                <div class="d-flex align-items-end justify-content-between">
                  <div class="recipeItemHead mb-3">
                    {{ "Recipe Items" }}
                  </div>
                  <div
                    v-if="
                      !recipeDetails.recipe_is_combo &&
                      recipeDetails.is_sub_recipe == 'N'
                    "
                    class="
                      d-flex
                      justify-content-end
                      align-self-center
                      mb-2
                      width40p
                    "
                  >
                      <div class="dropdown-curve-container">
                        <label
                          :class="
                            SelectedSubRecipes.length > 0 ? 'shift-up' : ''
                          "
                          >{{ "Add Sub Recipe" }}</label
                        >
                        <multiselect
                          v-model="SelectedSubRecipes"
                          track-by="recipe_name"
                          label="recipe_name"
                          :options="ms_sub_recipes"
                          @select="onSelectSubRecipe"
                          @remove="onRemoveSubRecipe"
                          :multiple="true"
                        ></multiselect>
                      </div>
                  </div>
                </div>
                <div class="row">
                  <div
                    class="col-lg-12 col-xl-12 align-self-center mb-2"
                    v-for="(itemArr, arrIndex) in recipeItems"
                    :key="arrIndex"
                  >
                    <div class="recipe-box">
                      <div
                        class="sub_recipe_name"
                        v-if="
                          itemArr.length > 0 &&
                          itemArr[0].hasOwnProperty('subrecipe_name') &&
                          itemArr[0].subrecipe_name
                        "
                      >
                        {{ itemArr[0].subrecipe_name }}
                        &nbsp;<span class="text-truncate fs-12 text-secondary"
                          >Sub-recipe</span
                        >
                      </div>
                      <div class="row">
                        <div class="col-md-11">
                          <div
                            class="row"
                            v-for="(item, index) in itemArr"
                            :key="index"
                          >
                            <!-- IMAGE DIMENSION -->
                            <div class="col-md-3 mb-1">
                              <div class="dropdown-curve-container">
                                <label
                                  :class="
                                    item.raw_material_name.length > 0
                                      ? 'shift-up'
                                      : ''
                                  "
                                  >{{ $t("select") }}
                                  {{ $tc("rawmaterials", 1) }}</label
                                >
                                <b-dropdown
                                  :disabled="item.disabled"
                                  :text="item.raw_material_name"
                                  variant="dropdown-curve"
                                  class="w-100"
                                >
                                  <div class="px-2 pb-2">
                                    <input
                                      required
                                      autofocus
                                      type="search"
                                      placeholder="Search Raw Material"
                                      class="form-control form-control-sm"
                                      v-on:keyup="onSearchRawMaterial()"
                                      v-on:keydown="onSearchRawMaterial()"
                                      v-on:search="onSearchRawMaterial()"
                                      v-model="searchRawMaterial"
                                    />
                                  </div>
                                  <b-dropdown-item
                                    v-for="(
                                      rawMaterial, rawMaterialKey
                                    ) in rawMaterials"
                                    :key="rawMaterialKey"
                                    v-on:click="
                                      onSelectHandler(
                                        rawMaterial,
                                        'rawMaterial',
                                        arrIndex,
                                        index
                                      )
                                    "
                                    >{{ rawMaterial.rm_name }}</b-dropdown-item
                                  >
                                </b-dropdown>
                                <p class="error_message">
                                  <span
                                    v-if="
                                      submitted &&
                                      item.raw_material_name.length == 0
                                    "
                                    >Please Select Raw Material.</span
                                  >
                                </p>
                              </div>
                            </div>

                            <div class="col-md-2 mb-1">
                              <div class="d-flex align-items-center">
                                <div class="input-material">
                                  <input
                                    class="text-right"
                                    :disabled="item.disabled"
                                    :class="{ error: errors.has('qty') }"
                                    style="text-align: right"
                                    type="text"
                                    v-model="item.ri_quantity"
                                    placeholder="."
                                    :name="'qty' + item._uniId + index"
                                    :id="'qty' + item._uniId + index"
                                    v-validate="'required|decimal'"
                                  />
                                  <label>{{ $t("quantity") }}</label>
                                </div>
                                <!-- <Tooltip :title="$t('recipe_quantity_tooltip')" /> -->
                              </div>
                              <p class="error_message">
                                <span
                                  v-if="
                                    submitted &&
                                    errors.has(`${'qty' + item._uniId + index}`)
                                  "
                                  >{{
                                    !item.ri_quantity
                                      ? "Qty is Required"
                                      : "Only Numbers and Decimals are allowed"
                                  }}</span
                                >
                              </p>
                            </div>

                            <div class="col-md-3 mb-1">
                              <div class="dropdown-curve-container">
                                <label
                                  :class="
                                    item.uom_unit && item.uom_unit.length > 0
                                      ? 'shift-up'
                                      : ''
                                  "
                                  >{{ $t("uom") }}</label
                                >
                                <b-dropdown
                                  :text="item.uom_unit"
                                  :disabled="item.disabled"
                                  variant="dropdown-curve"
                                  class="w-100"
                                >
                                  <b-dropdown-item
                                    v-for="(uom, uomkey) in item.uom_units"
                                    :key="uomkey"
                                    v-on:click="
                                      onSelectHandler(
                                        uom,
                                        'uom',
                                        arrIndex,
                                        index
                                      )
                                    "
                                    >{{ uom.uom_unit }}</b-dropdown-item
                                  >
                                </b-dropdown>
                                <p class="error_message">
                                  <span
                                    v-if="
                                      submitted && item.uom_unit.length == 0
                                    "
                                    >Please Select Unit of Measurement.</span
                                  >
                                </p>
                              </div>
                            </div>

                            <div class="col-md-3">
                              <div class="d-flex align-items-center">
                                <label class="mb-0 mr-3">{{
                                  $t("iscountable")
                                }}</label>
                                <label class="ios-switch">
                                  <input
                                    type="checkbox"
                                    :disabled="item.disabled"
                                    v-model="item.ri_is_countable"
                                    class="ios-checkbox"
                                    checked
                                  />
                                  <span class="switch-slider"></span>
                                </label>
                              </div>
                              <p class="error_message">
                                <span></span>
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-1 d-flex align-items-center mb-3">
                          <button
                            v-if="recipeItems.length > 1"
                            @click.prevent.stop="
                              decreaseImageSettingRow(arrIndex, 0)
                            "
                            class="btn-transparent"
                          >
                            <img
                              src="@/assets/img/icons/minus.svg"
                              height="35"
                              width="35"
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="
                      col-12
                      d-flex
                      align-items-center
                      justify-content-center
                      border-top
                      position-relative
                      my-3
                    "
                  >
                    <button
                      @click.prevent.stop="increaseImageSettingRow($event)"
                      class="btn-transparent add-more-button"
                    >
                      <img
                        src="@/assets/img/icons/plus.svg"
                        height="35"
                        width="35"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-12 text-center mt-4">
              <button
                :disabled="btenable"
                @click.prevent.stop="onFinalSubmit(true)"
                class="btn-blue"
              >
                {{ $t("save") }}
              </button>
              <button
                :disabled="btenable"
                @click.prevent.stop="onFinalSubmit(false)"
                class="btn-blue"
              >
                {{ $t("saveaddmore") }}
              </button>
              <button v-on:click="onResetForm()" class="btn-black">
                {{ $t("reset") }}
              </button>
              <b-button
                class="btn-outline-grey"
                variant="default"
                to="subrecipes"
                >{{ $t("cancel") }}</b-button
              >
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";
export default {
  data() {
    return {
      rawMaterialsCopy: [],
      searchRawMaterial: "",
      btenable: false,
      submitted: false,
      recipeItems: [],
      recipeDetails: {
        recipe_code: 0,
        recipe_name: "",
        // category_id: "",
        recipe_is_combo: false,
        is_sub_recipe: "Y",
        // recipe_expiry_days: "",
        recipe_description: "",
        recipe_is_active: true,
      },
      fc_list: [],
      rawMaterials: [],
      // selectedFoodCategory: "",
      ms_recipes: [],
      ms_sub_recipes: [],
      recipe_id: "",
      recipe_label: "",
      recipes: [],
      SelectedSubRecipes: [],
      units_of_measurements: [],
      recipeList: [
        {
          name: "Popcorn",
          qty: "50 gms",
        },
        {
          name: "Salt",
          qty: "2 gms",
        },
        {
          name: "Oil",
          qty: "2 gms",
        },
      ],
    };
  },
  mounted() {
    this.getfcList();
    this.getRawMaterialsList();
    this.increaseImageSettingRow();
    this.getRecipesList();
    this.getSubRecipesList();
    // this.getunitofmeasurements();
  },
  methods: {
    onChangeSubRecipe(event) {
      if (event == "Y") {
        this.recipeDetails.is_sub_recipe = event;
        this.recipeDetails.recipe_is_combo = false;
      }
      this.recipeItems = [];
      this.recipes = [];
      this.SelectedSubRecipes = [];
      this.increaseImageSettingRow();
    },
    onSearchRawMaterial: function () {
      if (this.searchRawMaterial && this.searchRawMaterial.length > 0) {
        this.rawMaterials = this.rawMaterialsCopy.filter((x) => {
          if (
            x.rm_name
              .toLowerCase()
              .includes(this.searchRawMaterial.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.rawMaterials = this.rawMaterialsCopy;
      }
    },
    getunitofmeasurements: function () {
      let payload = {
        tableName: "ms_unit_of_measurement",
        uom_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.units_of_measurements = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    getSubRecipesList: function () {
      let payload = {
        tableName: "ms_recipes",
        recipe_is_active: "Y",
        recipe_is_combo: "N",
        is_sub_recipe: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.ms_sub_recipes = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    getRecipesList: function () {
      let payload = {
        tableName: "ms_recipes",
        recipe_is_active: "Y",
        recipe_is_combo: "N",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.ms_recipes = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    onRemoveRecipe: function (selectedOption, id) {
      this.recipeItems = this.recipeItems.filter((x) => {
        return x[0].recipe_id != selectedOption.recipe_id;
      });
    },
      onRemoveSubRecipe: function (selectedOption, id) {
      this.recipeItems = this.recipeItems.filter((x) => {
        return x[0].parent_sub_recipe_id != selectedOption.recipe_id;
      });
    },
    onChangeStatus: function (e) {
      if (this.recipeDetails.recipe_is_combo) {
        this.recipeItems = [];
        this.recipes = [];
      } else {
        this.recipeItems = [];
        this.recipes = [];
        this.increaseImageSettingRow();
      }
    },
    onSelectRecipe: function (selectedOption, id) {
      // this.recipeItems = [];
      let payload = {
        recipe_id: selectedOption.recipe_id,
      };
      PosFnbService.GetRecipe(payload)
        .then((response) => {
          const { data } = response;
          let tempArr = [];
          if (data && data.status && data.Records.length > 0) {
            data.Records.map((x) => {
              this.recipeItems.push([{
                disabled: false,
                subrecipe_name: "",
                _uniId: new Date().valueOf(),
                recipe_id: selectedOption.recipe_id,
                ri_id: x.ri_id,
                raw_material_id: x.rm_id,
                ri_quantity: x.ri_quantity,
                uom_id: x.uom_id,
                raw_material_name: x.rm_name,
                uom_unit: x.uom_unit,
                ri_is_countable: x.ri_is_countable == "Y" ? true : false,
                ri_is_active: x.ri_is_active == "Y" ? true : false,
              }]);
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    onSelectSubRecipe(selectedOption, id) {
      let payload = {
        recipe_id: selectedOption.recipe_id,
      };
      PosFnbService.GetRecipe(payload)
        .then((response) => {
          const { data } = response;
          let tempArr = [];
          if (data && data.status && data.Records.length > 0) {
            data.Records.map((x) => {
              tempArr.push({
                disabled: true,
                subrecipe_name: x.recipe_name,
                recipe_id: selectedOption.recipe_id,
                parent_sub_recipe_id: x.recipe_id,
                ri_id: x.ri_id,
                raw_material_id: x.rm_id,
                ri_quantity: x.ri_quantity,
                uom_id: x.uom_id,
                raw_material_name: x.rm_name,
                uom_unit: x.uom_unit,
                ri_is_countable: x.ri_is_countable == "Y" ? true : false,
                ri_is_active: x.ri_is_active == "Y" ? true : false,
              });
            });
            this.recipeItems.push(tempArr);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getRawMaterialsList: function () {
      let payload = {
        tableName: "ms_raw_materials",
        rm_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.rawMaterials = data.Records;
            this.rawMaterialsCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    getfcList: function () {
      let payload = {
        tableName: "ms_food_categories",
        fc_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.fc_list = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    onSelectFoodCategory: function (fc) {
      // this.selectedFoodCategory = fc.fc_category;
      // this.recipeDetails.category_id = fc.fc_id;
    },
    onSelectHandler: function (item, type, arrIndex, index) {
      if (type == "rawMaterial") {
        this.recipeItems[arrIndex][index].raw_material_id = item.rm_id;
        this.recipeItems[arrIndex][index].raw_material_name = item.rm_name;
        this.recipeItems[arrIndex][index].uom_id = null;
        this.recipeItems[arrIndex][index].uom_unit = "";
        this.searchRawMaterial = "";
        this.onSearchRawMaterial();
        this.getRelatedUom(arrIndex, index, item.rm_id);
      } else if (type == "uom") {
        this.recipeItems[arrIndex][index].uom_id = item.uom_id;
        this.recipeItems[arrIndex][index].uom_unit = item.uom_unit;
      }
    },
    getRelatedUom: function (arrIndex, index, rm_id) {
      PosFnbService.getUomFromRawMaterial({ rm_id })
        .then((response) => {
          // console.log('response :', response);/
          const { data } = response;
          if (data.status) {
            this.recipeItems[arrIndex][index].uom_units = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    increaseImageSettingRow: function () {
      this.recipeItems.push([
        {
          disabled: false,
          _uniId: new Date().valueOf(),
          subrecipe_name: "",
          raw_material_id: "",
          ri_quantity: "",
          uom_id: "",
          raw_material_name: "",
          uom_unit: "",
          ri_is_countable: false,
          ri_is_active: true,
          uom_units: [],
        },
      ]);
    },
    decreaseImageSettingRow: function (arrIndex, index) {
      if (
        this.recipeItems[arrIndex][index].hasOwnProperty("parent_sub_recipe_id")
      ) {
        let tempIndex = this.SelectedSubRecipes.findIndex((x) => {
          return (
            x.recipe_id ==
            this.recipeItems[arrIndex][index].parent_sub_recipe_id
          );
        });
        if (tempIndex > -1) {
          this.SelectedSubRecipes.splice(tempIndex, 1);
        }
      }
      this.recipeItems.splice(arrIndex, 1);
      this.$forceUpdate();
    },
    removeRecipeItem: function (index) {
      this.recipeList.splice(index, 1);
    },
    onResetForm: function () {
      this.selectedFoodCategory = "";
      this.recipeItems = [];
      this.recipeDetails = {
        recipe_name: "",
        recipe_code: "",
        category_id: "",
        recipe_is_combo: false,
        // recipe_expiry_days: "",
        recipe_description: "",
        recipe_is_active: true,
      };
      this.recipeItems = [
        [
          {
            disabled: false,
            _uniId: new Date().valueOf(),
            subrecipe_name: "",
            raw_material_id: "",
            ri_quantity: "",
            uom_id: "",
            raw_material_name: "",
            uom_unit: "",
            ri_is_countable: true,
            ri_is_active: true,
          },
        ],
      ];
    },
    onFinalSubmit: function (flag) {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        console.log("valid :", valid);
        if (valid) {
          let finalSubmitArray = [];

          this.recipeItems.map((x) => {
            x.map((y) => {
              finalSubmitArray.push(y);
            });
          });
          console.log("finalSubmitArray", finalSubmitArray);
          this.btenable = true;
          let payload = {
            ...this.recipeDetails,
            selectedRecipe: finalSubmitArray,
          };
          PosFnbService.AddRecipe(payload)
            .then((response) => {
              this.btenable = false;
              const { data } = response;
              if (data && data.status) {
                this.onResetForm();
                if (flag) {
                  this.$router.push({
                    path: "subrecipes",
                  });
                  this.$toasted.show(data.message);
                }
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError); //message
        }
      });
    },
  },
};
</script>

<style>
.recipe-box-container {
  /* box-shadow: 0px 0px 7px -5px; */
  border-radius: 10px;
  padding: 12px 20px 20px 20px;
  margin: 5px;
}

.recipe-box {
  /* border: 1px solid #202d3633;
  border-radius: 20px;
  padding: 18px 0px 0px 22px; */
  border: 1px solid #202d3617;
  border-radius: 20px;
  padding: 18px 0px 0px 22px;
  background: #d3d3d326;
}

.sub_recipe_name {
  margin-left: 5px;
  font-size: 17px;
  font-weight: 600;
  color: #3876d2;
  margin-top: -15px;
  margin-bottom: 20px;
}

.recipeItemHead {
  font-size: 18px;
  text-transform: uppercase;
  font-weight: bold;
}
.width40p {
  width: 40%;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/RecipesComponents/addSubRecipe.vue